import React, { useState, useEffect, Fragment } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Card, CircularProgress, Grid, IconButton, makeStyles, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography, withStyles, Collapse, Icon } from '@material-ui/core';
import { blueGrey, grey } from '@material-ui/core/colors';
import empty from './notransaction.png'
import ActionBar from './ActionBar';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { format } from 'date-fns'
import TransactionStatus from './TransactionStatus';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import LoadingContainer from "../../../../components/LoadingContainer";

const TransactionTable = (props) => {

    const classes = useStyles()
    const {data, total, tableFilter, onUpdateTableFilter, onSelectedItem, loading} = props

    const [open, setOpen] = useState(false)
    const [innerData, setInnerData] = useState([])
    const [selected, setSelected] = useState(null)
    const [sorting, setSorting] = useState(null)


    useEffect(() => {
        let temp = [...data]
        if(sorting){
            if(sorting.action === 'asc'){
                temp.sort((a,b) => {
                    if(a[sorting.key] > b[sorting.key]) return 1
                    if(a[sorting.key] < b[sorting.key]) return -1
                    return 0
                })
            }else{
                temp.sort((a,b) => {
                    if(a[sorting.key] > b[sorting.key]) return -1
                    if(a[sorting.key] < b[sorting.key]) return 1
                    return 0
                })
            }
            
        }
        setInnerData(temp)
    }, [data, sorting])



    //console.log('Render this data',data)

    const onActiveFilter = (pos,info) => {
        console.log(pos)
        if(info.key !== '' && info.key){
            let data2send = {
                x:pos,
                icon:'arrow_drop_up',
                action:'asc', 
                key:info.key
            }
            if(!sorting){
                setSorting(data2send)
            }else{
                // If exists
                switch(sorting.action){
                    case 'asc':
                        data2send = {...data2send, icon:'arrow_drop_down', action:'desc'}
                        break;
                    case 'desc':
                        data2send = null
                        break;
                }
                setSorting(data2send)
            }
        }
        
    }


    const onSelected = (data) => {
        console.log(data)
        if(selected){
            //There is something
            if(JSON.stringify(selected) === JSON.stringify(selected)){
                console.log('Cerrar')
                setSelected(null)
            }else{
                console.log('Abrir')
                setSelected(data)
            }
        }else{
            console.log('Abrir')
            setSelected(data)
        }
        
    }


    return ( 
        <div>
            <Card style={{background:'white', minHeight:300, position:'relative'}}>
                <LoadingContainer loading={loading} />
                <TableContainer className={classes.table}>
                    <Table stickyHeader>
                        <TableHead>
                            <TableRow>
                                {header.map((item, key)=>{

                                    let enableSort = false
                                    if(sorting){
                                        enableSort = sorting.x === key
                                    }

                                    return(
                                        <TableCell className={classes.cell_header}  key={`th-${item.id}`} padding={item.padding??undefined}>
                                            <div onClick={() => onActiveFilter(key, item)} style={{cursor:'pointer'}}>
                                                <Grid container wrap='nowrap' alignItems='center' justify='center'>
                                                    <Grid item>
                                                        <Typography className={classes.cell_text_header} align='center' >
                                                            {item.label}
                                                        </Typography>
                                                    </Grid>
                                                    {enableSort ?<Grid item>
                                                        
                                                        <Icon style={{color:'white', marginTop:4}}>
                                                            {sorting.icon}
                                                        </Icon>
                                                        
                                                    </Grid> :null}
                                                </Grid>
                                            </div>
                                            
                                            
                                        </TableCell>
                                    )
                                })}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                                {innerData.map(item=>{
                                    
                                    const {idTran, requestDate, traceUuid, groupDescription, merchantDescription, cardholderName,cardLast4Digits,
                                        source,transType, transTypeDescription, requestAmount, status, childTransactions} = item
        
                                    const _date = new Date(requestDate)
                                    const _date_date = format(_date, 'MM/dd/yy')
                                    const _date_time = format(_date, 'HH:mm:ss')
        
                                    const gpo = groupDescription ? getFirstLetters(groupDescription) : '-'
                                    const mer = merchantDescription ? getFirstLetters(merchantDescription) : '-'

                                    let open = false
                                    if(selected) open = selected.idTran === idTran

                                    return(
                                        <Fragment>
                                            <TableRow key={`tr-${idTran}`}>
                                                <TableCell className={classes.cell_body}  padding='checkbox'>
                                                    <IconButton aria-label="expand row" size="small" onClick={() => onSelected(item)}>
                                                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                                    </IconButton>
                                                </TableCell>
                                                <TableCell className={classes.cell_body}  padding='checkbox'>
                                                    <Typography className={classes.text}>{idTran}</Typography>
                                                </TableCell>
                                                <TableCell className={classes.cell_body} >
                                                    <Grid container direction='column'>
                                                        <Grid item>{_date_date}</Grid>
                                                        <Grid item>{_date_time}</Grid>
                                                    </Grid>
                                                </TableCell>
                                                <TableCell className={classes.cell_body} >
                                                    <Typography className={classes.text}>{traceUuid}</Typography>
                                                </TableCell>
                                                <TableCell className={classes.cell_body} >
                                                    <LightTooltip title={groupDescription} className={classes.tooltip}>
                                                        <div >
                                                            {gpo}
                                                        </div>
                                                    </LightTooltip>
                                                </TableCell>
                                                <TableCell className={classes.cell_body}  >
                                                    <LightTooltip title={merchantDescription} className={classes.tooltip}>
                                                        <div >
                                                            {mer}
                                                        </div>
                                                    </LightTooltip>
                                                </TableCell>
                                                <TableCell className={classes.cell_body}  >
                                                    <Typography className={classes.text} style={{maxWidth:300}}>{cardholderName}</Typography>
                                                </TableCell>
                                                <TableCell className={classes.cell_body} >
                                                    <Typography className={classes.text} noWrap >{`**** ${cardLast4Digits}`}</Typography>
                                                </TableCell>
                                                <TableCell className={classes.cell_body} >
                                                    <Typography className={classes.text}>{source}</Typography>
                                                </TableCell>
                                                <TableCell className={classes.cell_body} >
                                                    <LightTooltip title={transTypeDescription} className={classes.tooltip}>
                                                        <div >
                                                            {transType}
                                                        </div>
                                                    </LightTooltip>
                                                </TableCell>
                                                <TableCell className={classes.cell_body} >
                                                    <TransactionStatus status={status}/>
                                                </TableCell>
                                                <TableCell className={classes.cell_body} >
                                                    <Typography className={classes.text}>{`$${requestAmount}`}</Typography>
                                                </TableCell>
                                                
                                            </TableRow>
                                            <TableRow>
                                                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={13}>
                                                    <Collapse in={open} timeout="auto" unmountOnExit>
                                                        <div>
                                                            <Grid container>
                                                                {childTransactions.map(el => {

                                                                const {transTypeDescription, idTran, requestDate, commision, requestAmount, responseAmount,
                                                                    tranGuid, hasResponse, approved, responseCode, responseMessage} = el

                                                                    const reqdate = new Date(requestDate)
                                                                    const date_date = format(reqdate, 'MM/dd/yy')
                                                                    const date_time = format(reqdate, 'HH:mm:ss')

                                                                return(
                                                                    <Grid item xs={12} key={`childtran-${idTran}`}>
                                                                        <div className={classes.child_trans}>
                                                                            <Typography className={classes.child_title}>{transTypeDescription}</Typography>
                                                                            <Grid container spacing={2}>
                                                                                <Grid item>
                                                                                    <Typography className={classes.child_body}>{idTran}</Typography>
                                                                                </Grid>
                                                                                <Grid item>
                                                                                    <Typography className={classes.child_body}>{date_date}</Typography>
                                                                                </Grid>
                                                                                <Grid item>
                                                                                    <Typography className={classes.child_body}>{date_time}</Typography>
                                                                                </Grid>
                                                                            </Grid>
                                                                            <div>
                                                                                <Grid container spacing={4}>
                                                                                    <Grid item>
                                                                                        <VerticalData label='Request amount' data={`$${requestAmount}`} />
                                                                                    </Grid>
                                                                                    <Grid item>
                                                                                        <VerticalData label='Commission' data={`$${commision ? commision : 0.00}`} />
                                                                                    </Grid>
                                                                                    <Grid item>
                                                                                        <VerticalData label='Response amount' data={`$${responseAmount}`} />
                                                                                    </Grid>
                                                                                    <Grid item>
                                                                                        <VerticalData label='Transaccion ID' data={`$${idTran}`} />
                                                                                    </Grid>
                                                                                    <Grid item>
                                                                                        <VerticalData label='Trace ID' data={`$${tranGuid}`} />
                                                                                    </Grid>
                                                                                    <Grid item>
                                                                                        <VerticalData label='Response?' data={`${hasResponse ? 'Yes' : 'No'}`} />
                                                                                    </Grid>
                                                                                    <Grid item>
                                                                                        <VerticalData label='Status' data={`${approved ? 'Approved' : 'Rejected'}`} />
                                                                                    </Grid>
                                                                                    <Grid item>
                                                                                        <VerticalData label='Response Code' data={ responseCode ? responseCode : '-'} />
                                                                                    </Grid>
                                                                                    <Grid item>
                                                                                        <VerticalData label='Response Message' data={responseMessage ? responseMessage : '-'} />
                                                                                    </Grid>
                                                                                </Grid>
                                                                            </div>
                                                                        </div>
                                                                    </Grid>
                                                                )
                                                                })}
                                                            </Grid>
                                                        </div>
                                                    </Collapse>
                                                </TableCell>
                                            </TableRow>
                                        </Fragment>
                                        
                                    )
                                })}
                        </TableBody>
                    </Table>

                </TableContainer>
            </Card>
            



            {data && data.length ? <div className={classes.actions} style={{marginTop:16}}>
                <ActionBar total={total} tableFilter={tableFilter} onUpdateTableFilter={onUpdateTableFilter}/>
            </div> : null}
            
            {/*data.length === 0 && !loading ? (
                <div className={classes.nodata}>
                    <Grid container justify='center' alignItems='center' direction='column'>
                        <Grid item>
                            <img src={empty} alt='' width={120}/>
                        </Grid>
                        <Grid item>
                            <Typography>There are no transactions</Typography>
                        </Grid>
                    </Grid>
                </div>
                
            ) : null*/}

            {/*<Paper className={classes.paper}>
                {data && data.length ? (
                    <div className={classes.tableWrapper}>
                        <Table className={classes.table}>
                            {header ? (
                                <TableHead>
                                    <TableRow>
                                        {header.map(item=>{
                                            return(
                                                <TableCell className={classes.cell_body}  padding={item.id === 1 ? 'default' : 'default'} className={classes.cellHeader} key={item.id.toString()} style={{...item.style}}>
                                                    <Typography variant='subtitle2' style={{fontSize:14,color:'inherit', fontWeight:600}} >{item.label}</Typography>
                                                </TableCell>
                                            )
                                        })}
                                    </TableRow>
                                </TableHead>
                            ):null}
                            <TableBody className={classes.tablebody}>
                                {data.map((item,key) => {
                                    const {id_pharma, name, email, rfc, pharma_status_id,
                                        cancelled_orders_total, delivered_orders_total, in_progess_orders_total, overdue_orders_total, orders_total} = item

                                    return(
                                        <TableRow key={key.toString()} className={classes.row} >
                                            <TableCell className={classes.cell_body}  className={classes.cell} onClick={() => onSelectedItem(item)}><Typography variant='body1'>{id_pharma}</Typography></TableCell>
                                            <TableCell className={classes.cell_body}  className={classes.cell} onClick={() => onSelectedItem(item)}><Typography variant='body1'>{name}</Typography></TableCell>
                                            <TableCell className={classes.cell_body}  className={classes.cell} onClick={() => onSelectedItem(item)}><Typography variant='body1'>{delivered_orders_total}</Typography></TableCell>
                                            <TableCell className={classes.cell_body}  className={classes.cell} onClick={() => onSelectedItem(item)}><Typography variant='body1'>{in_progess_orders_total}</Typography></TableCell>
                                            <TableCell className={classes.cell_body}  className={classes.cell} onClick={() => onSelectedItem(item)}><Typography variant='body1'>{cancelled_orders_total}</Typography></TableCell>
                                            <TableCell className={classes.cell_body}  className={classes.cell} onClick={() => onSelectedItem(item)}><Typography variant='body1'>{rfc}</Typography></TableCell>
                                        </TableRow>
                                    )
                                })}
                                
                            </TableBody>
                        </Table>
                    </div>
                    
                ): null}
                            </Paper >*/}
            
            
        </div>

     );
}

const useStyles = makeStyles(theme => ({
    table:{
        //width:'100%',
        //overflowX: 'auto',
        //background:'red'
        maxHeight:500,
        //minWidth:1100
    },
    table_wrapper:{
        minWidth:800,
        maxHeight:500
    },
    header:{
        display:'flex',
        wrap:'no-wrap'
    },
    cell_header:{
        background:theme.palette.primary.dark,
        
        //background:'white',
        //fontWeight:700,
        fontSize:16,
        boxSizing:'border-box',
        padding:4,
        textAlign:'center'
    },
    cell_body:{
        //width:140,
        fontWeight:400,
        fontSize:16,
        boxSizing:'border-box',
        //padding:4,
        color:blueGrey[700],
        fontWeight:500,

    },
    cell_text_header:{
        color:'white',
        fontWeight:700,
        paddingLeft:8
    },
    child_title:{
        color:theme.palette.primary.dark,
        fontSize:14,
        fontWeight:600
    },
    child_body:{
        color:blueGrey[700],
        fontSize:14,
        fontWeight:400
    },
    tooltip:{
        //background:"#3f51b5",
    },
    actions:{
       //maxWidth:400
    },
    child_trans:{
        padding:'24px 0px',
        borderBottom:`1px solid ${blueGrey[200]}`
    },
    /*tablebody:{
        //background:'white',
        //display:'block',
        //boxShadow:'0 10px 24px 0 rgba(82, 91, 115, .12)',
    },
    root:{},
    paper:{
        borderRadius:16,
        boxShadow:'0 10px 24px 0 rgba(82, 91, 115, .12)',
    },
    addIcon:{
        background:theme.palette.primary.main,
        borderRadius:'50%',
        color:'white',
        '&:hover':{
            background:theme.palette.primary.dark,
        }
    },
    cell:{
        borderColor:grey[200],
    },
    row:{
        '&:hover':{
            cursor:'pointer',
            background:grey[100]
        }
    },
    cellHeader:{
        color:theme.palette.primary.main,
        fontWeigth:600,
        paddingTop:16,
        paddingBottom:16
    },
    button:{
        background:theme.palette.primary.main,
        padding:'6px 12px',
        borderRadius:32,
        color:'white',
        '&:hover':{
            background:theme.palette.primary.dark,
        }
    },
    toolbar:{
        marginBottom:16,
        //border:'1px solid red'
    },
    actions:{
        marginTop:16
    },
    table:{
        minWidth:1100
    },
    tableWrapper:{
        overflowX: 'auto',
    },
    nodata:{
        marginTop:40
    }*/
}))

const LightTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: "#3f51b5",
      color: 'white',
      boxShadow: theme.shadows[1],
      fontSize: 14,
    },
  }))(Tooltip);

function getFirstLetters(str) {
    const firstLetters = str
      .split(' ')
      .map(word => word[0])
      .join('');
  
    return firstLetters;
  }
 
export default TransactionTable;

const VerticalData = ({label, data}) => {
    return(
        <div>
            <Typography variant='subtitle2'>{label}</Typography>
            <Typography variant='body2'>{data}</Typography>
        </div>
    )
}

const header = [
    {id:-1, label:'', padding:'checkbox',style:{width:80}},
    {id:1, key:'idTran', label:'ID', padding:'checkbox',style:{width:80}},
    {id:2, key:'requestDate', label:'Date/Time', style:{width:140}},
    {id:3, key:'traceUuid', label:'Trace ID', style:{width:200}},
    {id:4, key:'groupDescription', label:'Group', style:{width:100}},
    {id:5, key:'merchantDescription', label:'Merchant', style:{width:100}},
    {id:6, key:'cardholderName', label:'Name', style:{width:140}},
    {id:7, key:'', label:'Last 4 digits', style:{width:140}},
    {id:8, key:'', label:'Source', style:{width:140}},
    {id:9, key:'', label:'Type', style:{width:100}},
    {id:10, key:'', label:'Status', style:{width:140}},
    {id:11, key:'', label:'Amount', style:{width:140}},
]